import React, { useState } from "react";
import "./header.css";

const Header = () => {
  const [Menu, setMenu] = useState(false);

  return (
    <header className="header">
      <nav className="nav container">
        <a
          href="index.html"
          className={Menu ? "nav__logo__header" : "nav__logo"}
        >
          Rishabh
        </a>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div className={Menu ? "nav__menu show-menu" : "nav__menu"}>
          <ul className="nav__list grid">
            <li className="nav__item">
              <a href="#skills" className="nav__link active-link">
                <i className="uil uil-file-alt nav__icon"></i> Services
              </a>
            </li>
            <li className="nav__item">
              <a href="#work" className="nav__link">
                <i className="uil uil-briefcase nav__icon"></i> Work
              </a>
            </li>
            <li className="nav__item">
              <a href="#about" className="nav__link">
                <i className="uil uil-user nav__icon"></i> About
              </a>
            </li>
            <li className="nav__item">
              <a href="#faq" className="nav__link">
                <i className="uil uil-question-circle nav__icon"></i> FAQ
              </a>
            </li>
            <li className="nav__item">
              <a href="#contact" className="nav__link">
                <i className="uil uil-message nav__icon"></i> Contact
              </a>
            </li>
          </ul>
          <i
            className="uil uil-times nav__close"
            onClick={() => setMenu(!Menu)}
          ></i>
        </div>
        <div className={Menu ? "nav__logo__header" : "nav__logo"}>
          <div className="nav__toggle" onClick={() => setMenu(!Menu)}>
            <i className="uil uil-apps nav__logo"></i>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
